<ion-list lines="none" no-padding>
  <ion-item *ngFor="let menu of menus" (click)="menuClicked(menu)">
    <ion-label text-large font-bold>{{menu.displayText}}</ion-label>
  </ion-item>
</ion-list>
